import { useGetItemPrice } from '../hooks/useGetItemPrice';
import { createHOCWithHookInside } from './createHOCWithHookInside';

/**
 * @deprecated use "useGetItemPrice"
 */
export const withGetItemPrice = createHOCWithHookInside('WithGetItemPrice', useGetItemPrice);
